// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"DeleteIcon-deleteIcon-2dGpHW"};